<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: Poppins, Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.swal2-title {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-text {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-footer {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-button {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-close {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-icon {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-modal {
  font-family: Poppins, Roboto, sans-serif;
}

.swal2-popup {
  font-family: Poppins, Roboto, sans-serif;
}

.mapboxgl-popup-close-button {
  font-size: 20px;
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 5px;
}
</style>
